export default {
  init() {
    // JavaScript to be fired on all pages
    $('.banner .hamburger').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      $('.nav-mobile').slideToggle();
    });

    $('.custom-show-hide .elementor-button').on('click', function(e){
      e.preventDefault();
      $(this).parent().parent().parent().parent().find('.elementor-widget-wp-widget-text, .elementor-widget-text-editor').toggleClass('active');
    });

   /* $('.team-member').on('mouseover', function(){
      var target_profile = $(this).data('target');
      $('.team-profile.active').removeClass('active');
      $(target_profile).addClass('active');
    }).on('mouseout', function(){
      var target_profile = $(this).data('target');
      $(target_profile).removeClass('active');
    });*/

    $('.team-read-bio a').on('click', function(e){
      e.preventDefault();
      var target_profile = $(this).parent().parent().parent().data('target');

      // Remove 'active' class from all profiles before toggling the new one
      $('.team-profile').removeClass('active');
      $(target_profile).toggleClass('active');

      if($(target_profile).hasClass('active')) {
        $(this).html('Hide Bio');
      }
      else {
        $(this).html('Read Bio');
      }
    });

    $('.back').on('click', function(e){
      e.preventDefault();
      history.back();
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js